import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e107559"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "form-label"
}
const _hoisted_2 = ["type"]
const _hoisted_3 = {
  key: 0,
  class: "fas fa-eye"
}
const _hoisted_4 = {
  key: 1,
  class: "fas fa-eye-slash"
}
const _hoisted_5 = {
  key: 1,
  class: "p-1"
}
const _hoisted_6 = {
  key: 0,
  class: "password-tip"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "form-label" }, "Confirmar senha", -1))
const _hoisted_10 = ["type"]
const _hoisted_11 = {
  key: 0,
  class: "p-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_password_meter = _resolveComponent("password-meter")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isRegister)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Senha"))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["password-container", {'mb-3': !_ctx.isRegister}])
    }, [
      _withDirectives(_createElementVNode("input", {
        class: "password-input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
        placeholder: "Digite sua senha",
        type: _ctx.showPassword ? 'text' : 'password',
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validatePassword()))
      }, null, 40, _hoisted_2), [
        [_vModelDynamic, _ctx.password]
      ]),
      (!_ctx.isRegister || _ctx.isReset)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "password-toggle",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.togglePasswordVisibility && _ctx.togglePasswordVisibility(...args)))
          }, [
            (_ctx.showPassword)
              ? (_openBlock(), _createElementBlock("i", _hoisted_3))
              : (_openBlock(), _createElementBlock("i", _hoisted_4))
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.isRegister)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_password_meter, {
            onScore: _ctx.onScore,
            password: _ctx.password
          }, null, 8, ["onScore", "password"]),
          (_ctx.password.length > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                _createTextVNode(_toDisplayString(_ctx.safetyFeedback) + " ", 1),
                (_ctx.password.length < 6)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "A senha deve ter pelo menos 6 caractéres."))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isConfirm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            class: "password-input mt-1",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.confirmationPassword) = $event)),
            placeholder: "Confirme sua senha",
            type: _ctx.showPassword ? 'text' : 'password',
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validatePassword()))
          }, null, 40, _hoisted_10), [
            [_vModelDynamic, _ctx.confirmationPassword]
          ]),
          (_ctx.password.length > 0 && !_ctx.passwordsMatch)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("span", {
                  class: _normalizeClass(["password-tip", {'wrong-password': _ctx.passwordsMatch === false}])
                }, _toDisplayString(_ctx.confirmationText), 3)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}